import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';

import {UiModule} from '../shared/ui/ui.module';

import {ProcessReplyEmailComponent} from './process-reply-email.component';
import {ProcessReplyEmailRoutesModule} from './process-reply-email.routes.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    ProcessReplyEmailRoutesModule,
    UiModule
  ],
  declarations: [
    ProcessReplyEmailComponent
  ],
  exports: [
    ProcessReplyEmailComponent
  ]
})
export class ProcessReplyEmailModule {
}
